export default "__VITE_ASSET__DOHJW3_G__"